var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.fieldDescription.type.values.length
        ? _c("SelectPicker", {
            attrs: { options: _vm.fieldDescription.type.values },
            nativeOn: {
              click: function ($event) {
                $event.stopPropagation()
              },
            },
            model: {
              value: _vm.currentValue,
              callback: function ($$v) {
                _vm.currentValue = $$v
              },
              expression: "currentValue",
            },
          })
        : _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.lazy",
                value: _vm.currentValue,
                expression: "currentValue",
                modifiers: { lazy: true },
              },
            ],
            staticClass: "form-control",
            staticStyle: { "min-width": "250px" },
            attrs: { type: "text", placeholder: _vm.fieldName },
            domProps: { value: _vm.currentValue },
            on: {
              click: function ($event) {
                $event.stopPropagation()
              },
              change: function ($event) {
                _vm.currentValue = $event.target.value
              },
            },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }